export default __webpack_public_path__ + "static/media/regulatory--no-u-turn--g2.7911ab30.png";